module.exports = __webpack_public_path__ + "media/wi-monitor_202103161453.636d0bc6.mp4";